import OrderTypeLayout from "@/pages/order-type/components/OrderTypeLayout";

export default function StopOrders() {
  return <OrderTypeLayout slug="stop-orders" />;
}